import { createSlice } from '@reduxjs/toolkit'

import { ApiStatus, failedResponse, inIdle, inProgress, successResponse } from 'redux/toolkit/api'
import { IpirAccountResponse, getIpirAccount } from './ipirApiThunks'

export interface IpirState {
  api: {
    getIpirAccount: ApiStatus
  }
  account: IpirAccountResponse | undefined
}

// initialState
export const INITIAL_STATE: IpirState = {
  api: {
    getIpirAccount: inIdle
  },
  account: undefined
}

/* eslint-disable no-param-reassign */
export const ipirSlice = createSlice({
  name: 'IPIR',
  initialState: INITIAL_STATE,
  reducers: {
    reset: () => ({
      ...INITIAL_STATE
    }),
    resetTokens: state => {
      state.api.getIpirAccount = INITIAL_STATE.api.getIpirAccount
      state.account = INITIAL_STATE.account
    }
  },
  extraReducers: builder => {
    builder
      // getLdapSyncStats
      .addCase(getIpirAccount.pending, state => {
        state.api.getIpirAccount = inProgress
      })
      .addCase(getIpirAccount.fulfilled, (state, action) => {
        state.api.getIpirAccount = successResponse
        state.account = action.payload
      })
      .addCase(getIpirAccount.rejected, (state, action) => {
        state.api.getIpirAccount = failedResponse(action.payload)
      })
  }
})
/* eslint-enable no-param-reassign */

export const { reset, resetTokens } = ipirSlice.actions

export { getIpirAccount }

export default ipirSlice.reducer
